import { createFileRoute } from '@tanstack/react-router';

import { AdminTipDetailPage } from '@/components/admin/tip-detail-page';
import { adminHead } from '@/lib/seo';
import { adminGetTipFn } from '@/server/functions/tips';

export const Route = createFileRoute('/_admin/admin/tips_/$id')({
    component: TipDetailRoute,
    head: ({ params }) =>
        adminHead('ידיעה מהקוראים', `/admin/tips/${encodeURIComponent(params.id)}`),
    staleTime: 0,
    preloadStaleTime: 0,
    loader: ({ params }) => adminGetTipFn({ data: { id: params.id } }),
});

function TipDetailRoute() {
    const data = Route.useLoaderData();
    return (
        <AdminTipDetailPage
            key={`${data.tip.id}:${String(data.tip.updatedAt)}`}
            tip={data.tip}
            photoDataUrl={data.photoDataUrl}
        />
    );
}
